import { api } from './axios';
import { authService } from './auth';

// Interface para o histórico vindo da API
export interface HistoricoAPI {
  id: number;
  acao: string;
  comentario?: string; // Comentário associado à ação (pode estar presente em qualquer tipo de ação)
  demanda_fk: number;
  editor_fk: number;
  afetado_fk?: number;
  edicao_fk?: number;
  anexo_fk?: number;
  created_at: string;
  updated_at: string;
  editor: {
    id: number;
    name: string;
    email: string;
    funcao_usuario: string;
    cargo_usuario: string;
    azure_id?: string;
  };
  afetado?: {
    id: number;
    name: string;
    email: string;
    funcao_usuario: string;
    cargo_usuario: string;
    affected_name?: string;
    affected_email?: string;
  };
  edicao?: {
    id: number;
    demanda_fk: number;
    snapshot: any;
    changes: Record<string, any>;
    created_at: string;
    updated_at: string;
  };
  anexo?: {
    id: number;
    nome_anexo: string;
    anexo: string;
    demanda_fk: number;
    active: boolean;
    created_at: string;
    updated_at: string;
  };
}

// Interface para edições vindo da API
export interface EdicaoAPI {
  id: number;
  demanda_fk: number;
  snapshot: any;
  changes: Record<string, any>;
  created_at: string;
  updated_at: string;
}

// Interface para a resposta completa da API
export interface HistoricoCompleteAPI {
  historico: HistoricoAPI[];
  edicoes: EdicaoAPI[];
  demanda_atual: any;
}

class HistoricoService {
  /**
   * Obter histórico completo de uma demanda específica
   */
  async getHistoricoDemanda(demandaId: number): Promise<HistoricoCompleteAPI> {
    await authService.ensureSanctumInitialized();
    
    const response = await api.get<HistoricoCompleteAPI>(`/demandas/${demandaId}/historico`);
    return response.data;
  }
}

export const historicoService = new HistoricoService();
